<script setup>
import RichText from '@/components/pages/RichText.vue';
import FordButton from '@/components/FordButton.vue';
import GenericEvent from '@/components/events/GenericEvent.vue';
import DisclosurePopover from '@/components/DisclosurePopover.vue';
import { useRoute } from 'vue-router';

const route = useRoute();

defineProps({
  event: Object,
});

const createAssetURL = (fileName) => `${process.env.VUE_APP_ASSET_PATH}${fileName}`;

// Sat Sept 13, 2022
// const formatDate = (dateString) => dayjs(dateString).format('ddd MMM D, YYYY');
</script>
<template>
  <generic-event :event="event">
    <template v-slot:hero-details>
      <div class="mb-[1.5rem] hidden tablet:block">
        <slot name="hero-details"></slot>
      </div>
    </template>
    <template v-slot:hero-button>
      <slot name="hero-button">
      </slot>
    </template>
    <template v-slot:info-area-details>
      <div
        class="
          grid
          grid-cols-1
          tablet:grid-cols-3
          tablet:gap-[2rem] desktop:gap-x-[8rem]
        ">
        <div>
          <dl class="mb-[1.5rem]">
            <slot name="info-details"></slot>
          </dl>
          <img v-if="event?.assetForRegistration"
            :src="createAssetURL(event.assetForRegistration?.fileName)"
            class="h-[12rem] w-full object-cover object-center"
            alt=""
          />
          <div v-if="route?.name === 'WaitingRoom' && event.disclosureWaitingRoom" class="mt-7">
            <disclosure-popover>
              {{ event.disclosureWaitingRoom }}
            </disclosure-popover>
          </div>
        </div>
        <slot name="info-area-additional">
          <div class="tablet:row-start-1 tablet:col-span-2">
            <rich-text :content="event?.descriptionDetail" class="mb-8" />
            <div v-if="event.disclosureEvent" class="mb-8">
              <disclosure-popover>
                {{ event.disclosureEvent }}
              </disclosure-popover>
            </div>
            <slot name="info-area-button">
              <ford-button v-if="isFordProOwned"
                @method="toggleRegistrationModal"
                class="mb-[2rem]"
                transparent
                ariaLabel="Register for the Event">
                {{ event?.ctaLabel }}</ford-button>
              <div v-else
                class="
                  w-[12rem]
                  rounded-full
                  py-2
                  font-FordAntennaCondReg
                  desktop:text-lg
                  bg-ford-blue-dark
                  text-white
                  border border-ford-blue-dark
                  text-center
                  cursor-pointer
                "
              >
                <a
                  :href="event?.ctaExternalLink"
                  aria-label="Learn more about the event">
                  <div class="title-container">Learn More</div>
                </a>
              </div>
            </slot>
          </div>
        </slot>

      </div>
    </template>
  </generic-event>
</template>
